import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../interceptors/authErrorInterceptor';
import { RegisterTransactionRequest, RegisterTransactionResponse } from './fmsr.types';
import axiosBaseQuery from '../axiosBaseQuery';
import { adapter } from '../adapters';

export const fmsrService = createApi({
  reducerPath: 'fmsr',
  baseQuery: baseQueryWithReauth(axiosBaseQuery(adapter)),
  endpoints: (builder) => ({
    registerTransaction: builder.mutation<RegisterTransactionResponse, RegisterTransactionRequest>({
      query: (body) => ({
        url: '/transactions:register',
        method: 'post',
        body,
      }),
    }),
  }),
});

export const { useRegisterTransactionMutation } = fmsrService;
